import { useId, useState } from 'react';
import { Badge, Button, Offcanvas } from 'react-bootstrap';

// A floating "Filters" button pinned to the bottom-right of the screen that opens a
// right-hand slide-in Offcanvas panel (same affordance as the browse page's
// MobileFilterPanel, but shown at every width). The page passes its filter controls
// as children.
//
//   <SidePanelFilters badge={activeCount} onClear={resetFilters} onApply={applyFilters}>
//     …filter controls…
//   </SidePanelFilters>
//
//  - title    button + panel heading (default "Filters")
//  - badge    count of active filters - shown as a pill on the button
//  - onClear  optional; when given, a "Clear filters" button appears in the panel footer
//  - onApply  optional; when given, the footer's primary button says "Apply" and runs it
//             before closing (for filters that need an explicit submit, e.g. free-text that
//             can 400). Without it the primary button is just "Done" (live-applied filters).
export default function SidePanelFilters({ title = 'Filters', badge, onClear, onApply, children }) {
  const [open, setOpen] = useState(false);
  const titleId = useId();

  return (
    <>
      <Button
        variant="dark"
        className="mobile-filter-fab"
        onClick={() => setOpen(true)}
        aria-label={`Open ${title.toLowerCase()}`}
      >
        <span aria-hidden="true">⚙</span> {title}
        {badge != null && badge > 0 && <Badge bg="light" text="dark" className="ms-2">{badge}</Badge>}
      </Button>

      <Offcanvas
        show={open}
        onHide={() => setOpen(false)}
        placement="end"
        className="mobile-filter-panel"
        aria-labelledby={titleId}
      >
        <Offcanvas.Header closeButton>
          <Offcanvas.Title id={titleId}>{title}</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body className="d-flex flex-column">
          {children}
          <div className="mt-auto d-flex gap-2 pt-3 border-top">
            {onClear && (
              <Button variant="outline-secondary" className="flex-fill" onClick={onClear}>
                Clear filters
              </Button>
            )}
            <Button
              variant="primary"
              className="flex-fill"
              onClick={() => { onApply?.(); setOpen(false); }}
            >
              {onApply ? 'Apply' : 'Done'}
            </Button>
          </div>
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
}
